import Vue from 'vue';

import ElementResizeDetectorMaker from 'element-resize-detector'

Vue.prototype.$erd = ElementResizeDetectorMaker()